import { useMemo } from 'react';
import { useSmartLinkContext } from '@atlaskit/link-provider';
export var useAISummaryConfig = function useAISummaryConfig() {
  var _useSmartLinkContext = useSmartLinkContext(),
    connections = _useSmartLinkContext.connections,
    product = _useSmartLinkContext.product,
    isAdminHubAIEnabled = _useSmartLinkContext.isAdminHubAIEnabled;
  return useMemo(function () {
    return {
      baseUrl: connections.client.baseUrlOverride,
      envKey: connections.client.envKey,
      product: product,
      isAdminHubAIEnabled: isAdminHubAIEnabled
    };
  }, [connections.client.baseUrlOverride, connections.client.envKey, product, isAdminHubAIEnabled]);
};